<template>
  <BaseModal overlay-class="lantern_modal">
    <div class="content">
      <h1>
        <span>{{ $_translations.value.modal_pre_game_lantern_title_pt1 }} <br></span>
        {{ $_translations.value.modal_pre_game_lantern_title_pt2 }}
      </h1>

      <p>{{ $_translations.value.modal_pre_game_lantern_subtitle }}</p>

      <BaseImage
        src="/static/images/lanterns/lantern_sign.svg"
        image-class="middle_img"
        alt="lantern"
      />

      <p>
        {{ $_translations.value.modal_pre_game_lantern_description_pt1 }}
        <span>
          {{ appSettingsStore.appProperties.timerForPuzzleGame || '-' }}
          {{ $_translations.value.modal_pre_game_lantern_description_pt2 }}
        </span>
        {{ $_translations.value.modal_pre_game_lantern_description_pt3 }}
      </p>

      <p>{{ $_translations.value.modal_pre_game_lantern_description_pt4 }}</p>

      <BaseButton @click:button="$emit('start:lanternGame')">
        {{ $_translations.value.modal_pre_game_lantern_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useBonusGameHook from '@/hooks/useBonusGame.js';

defineEmits(['start:lanternGame']);

const appSettingsStore = useAppSettingsStore();

const { addLanternStylesheet, removeLanternStylesheet } = useBonusGameHook();

onMounted(addLanternStylesheet);

onUnmounted(removeLanternStylesheet);
</script>
